class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this.openButton = document.querySelector(".open-drawer-menu");
    this.closeButton = this.querySelector(".drawer-menu__close");
    this.links_open = this.querySelectorAll("[data-open-mega-menu]");
    this.main_menu = this.querySelector(".drawer-menu__linklists");
    this.return_btn = this.querySelector(".drawer-menu__return");

    this.return_btn_collections = this.querySelectorAll("[data-drawer-return]");

    this.return_btn_collections.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.returnMenu(event).bind(this);
      });
    });

    this.openButton?.addEventListener("click", this.openMenu.bind(this));
    this.closeButton?.addEventListener("click", this.closeMenu.bind(this));

    this.links_open.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggleMenu(link).bind(this);
      });
    });

    this.return_btn?.addEventListener("click", (event) => {
      this.returnMenu(event).bind(this);
    });
  }

  openMenu(e) {
    e.preventDefault();
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-drawer");
  }

  closeMenu() {
    this.classList.remove("open");
    document.querySelector("body").classList.remove("shadow-drawer");
  }

  toggleMenu(link) {
    console.log(link);

    let currentLink = link;
    let menu = currentLink.getAttribute("data-open-mega-menu");
    console.log(currentLink, menu);
    let menuElement = this.querySelector(
      `.mega-menu__panel[data-mega-menu="${menu}"]`
    );
    let main_header = this.querySelector(".drawer-menu__header");

    console.log(menuElement);

    let parentMenu = currentLink.getAttribute("data-parent-menu");

    if (parentMenu) {
      parentMenu = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentMenu}"]`
      );
    }

    console.log(menuElement);
    main_header.classList.add("hidden");

    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--first.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelector(".mega-menu__panel--first.mega-menu__panel--actif")
        .classList.remove("mega-menu__panel--actif");
    }

    this.main_menu.classList.add("hidden");
    menuElement.classList.add("mega-menu__panel--actif");
    this.return_btn.classList.remove("hidden");
  }

  returnMenu(event) {
    event.preventDefault();
    let main_header = this.querySelector(".drawer-menu__header");
    let currentMenu = this.querySelector(".mega-menu__panel--actif");
    main_header.classList.remove("hidden");

    if (currentMenu.classList.contains("mega-menu__panel--second")) {
      currentMenu.classList.remove("mega-menu__panel--actif");
      let parentMenu = currentMenu.getAttribute("data-parent-menu");
      parentMenu = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentMenu}"]`
      );
      parentMenu.classList.add("mega-menu__panel--actif");
    } else {
      currentMenu.classList.remove("mega-menu__panel--actif");
      this.main_menu.classList.remove("hidden");
      this.return_btn.classList.add("hidden");
    }
  }
}

customElements.define("drawer-menu", DrawerMenu);
